import { IDestinationFiles } from '_/types/destinations/destinations.types';
import { SetFieldValueHandler } from '_/types/formik.types';
import { useCallback } from 'react';

import { ZIP_FILE_TYPES } from './DestinationForms.constants';
import { IDestinationForm, IUseFileTypeHandlers } from './DestinationForms.types';

export const useFileTypeHandlers = (
  setValue: SetFieldValueHandler<IDestinationForm>,
  files: IDestinationFiles,
): IUseFileTypeHandlers => {
  const setCompressionType = useCallback(
    ({ target }) => {
      setValue('compressionType', target.value);
    },
    [setValue],
  );

  const toggleFileFormatType = useCallback(
    ({ target }) => {
      setValue('fileType', target.value);
    },
    [setValue],
  );

  const toggleFileType = useCallback(
    ({ target }) => {
      const { checked, id } = target;
      const newFiles = { ...files, [id]: checked };

      // if something is being unchecked, need to make sure zip counterpart is also set accordingly
      if (ZIP_FILE_TYPES.includes(id + 'Zip') && !checked) {
        newFiles[id + 'Zip'] = checked;
      }

      setValue('files', newFiles);
    },
    [files, setValue],
  );

  return {
    setCompressionType: setCompressionType,
    toggleFileFormatType: toggleFileFormatType,
    toggleFileType: toggleFileType,
  };
};
